// extracted by mini-css-extract-plugin
export default {"container":"terms_container__6ZhC4","term-date":"terms_term-date__07KQL","header-container":"terms_header-container__JQsll"};